// extracted by mini-css-extract-plugin
module.exports = {"arrow":"styles_arrow__2YqhK","tooltip":"styles_tooltip__1yGy3","tooltipBody":"styles_tooltipBody__3wsuG"};